import React from "react"
import PropTypes from "prop-types"
import { CircularProgress } from "@mui/material"

const sizes = {
  small: 20,
  medium: 40,
  large: 60,
}

export default function Loading({
  align = "center",
  cover = "inline",
  size = "medium",
  color = "primary",
}) {
  return (
    <div className={`loading text-${align} cover-${cover}`}>
      <CircularProgress
        color={color}
        size={sizes[size]}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          marginTop: `${-sizes[size] / 2}px`,
          marginLeft: `${-sizes[size] / 2}px`,
        }}
      />
    </div>
  )
}

Loading.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]),
  color: PropTypes.string,
}
